const getAuthObj = () => {
  const authFromLocalStorage = window.localStorage.getItem('auth');
  if (authFromLocalStorage) {
    return JSON.parse(authFromLocalStorage);
  }
  return {};
};

export const getIsMemberLoggedIn = () => {
  const authObj = getAuthObj();
  return Object.keys(authObj).length > 0;
};

export const getMember = () => {
  const authObj = getAuthObj();
  return authObj.member || {};
};

export const getAuthToken = () => {
  const authObj = getAuthObj();
  return authObj.token || '';
};

export const setMemberAuthObj = userAuthObj => {
  window.localStorage.setItem('auth', JSON.stringify(userAuthObj));
};

export const deleteMemberAuthObj = () => {
  window.localStorage.removeItem('auth');
};
